@if (hearingSegments.length === 1) {
  <ftr-time-range-text
    class="complex-list-timeframes--single"
    divider="-"
    [timeRange]="hearingSegments[0].timeRange"
    [isOngoing]="isLive"
  ></ftr-time-range-text>
}

@if (hearingSegments.length > 1) {
  <span class="complex-list-timeframes--multiple" ftrTooltip [template]="allTimeframes" [showDash]="false"
    >{{ hearingSegments.length }} Timeframes</span
  >
}

<ng-template #allTimeframes>
  <ul class="complex-list-timeframes__list">
    @for (hearingSegment of hearingSegments; track hearingSegment; let last = $last) {
      <li>
        <ftr-time-range-text
          divider="-"
          [timeRange]="hearingSegment.timeRange"
          [isOngoing]="last && isLive"
        ></ftr-time-range-text>
      </li>
    }
  </ul>
</ng-template>
